import { useSuspenseQuery } from '@apollo/client'
import { FetchSharedUrlDocument } from '@salescore/client-api'
import { useMe } from '@salescore/client-common'
import { selectShareId, useAppSelector } from '@salescore/client-redux'

export const useSharedUrl = () => {
  const shareId = useAppSelector(selectShareId)
  const me = useMe()
  const {
    data: { sharedUrl },
  } = useSuspenseQuery(FetchSharedUrlDocument, {
    variables: {
      id: shareId ?? ``,
      organizationId: me.organization.id,
    },
  })
  return sharedUrl ?? undefined
}
